import { Icon } from 'components/Icon';
import {
  InternalRoute,
  MainMenuConfig,
} from 'controllers/ContentController/Routes';
import { TFunction } from 'i18next';
import React from 'react';
import { Link } from 'react-router-dom';
import { BigMenuProps, siteHeaderStyles } from './SiteHeader';
import { PrimaryFeature } from '../../utils/types';

type MainNavProps = BigMenuProps & {
  onMenuItemClick: (routeId: PrimaryFeature) => void;
  selectedPrimaryFeature: PrimaryFeature | null;
  getMenuItems: (menuSection: string) => (InternalRoute & {
    mainMenuConfig: MainMenuConfig;
  })[];
  isAuthEmpty: boolean;
  t: TFunction;
};

export const MainNav: React.FC<MainNavProps> = ({
  bigMenu,
  selectedPrimaryFeature,
  onMenuItemClick,
  getMenuItems,
  isAuthEmpty,
  t,
}) => {
  return (
    <>
      {!isAuthEmpty &&
        getMenuItems('primary').map(({ url, mainMenuConfig, routeId }) => (
          <Link
            key={`menu-item-${mainMenuConfig.title}`}
            to={url}
            onClick={() => onMenuItemClick(routeId as PrimaryFeature)}
            title={t(`linksOrButtons:navigation:${mainMenuConfig.title}`)}
            className={`hover:bg-primary flex h-8 items-center py-1 hover:text-white md:h-auto md:flex-col md:justify-center md:py-0 lg:h-6 lg:py-1 ${
              bigMenu ? siteHeaderStyles.bigMenuLinks : ''
            } md:box-content md:w-4 md:px-3 lg:w-full lg:px-0
    ${routeId === selectedPrimaryFeature && 'bg-primary text-white'}`}
          >
            <span
              className={`${siteHeaderStyles.menuItemSpanBase} ${
                bigMenu ? siteHeaderStyles.bigMenuIcons : 'lg:mx-auto'
              }
`}
            >
              <Icon
                name={mainMenuConfig.icon}
                title={t(`linksOrButtons:navigation:${mainMenuConfig.title}`)}
              />
            </span>
            <span
              className={`${
                bigMenu ? siteHeaderStyles.bigMenuLabels : 'md:hidden'
              } ml-2 md:ml-0`}
            >
              {t(`linksOrButtons:navigation:${mainMenuConfig.title}`)}
            </span>
          </Link>
        ))}
    </>
  );
};
